import { Item, MultiSelectProps } from './multi-select';
import { Option } from './Option';

export const OptionList = <T extends Item>({
  options,
  mode,
  itemDisplay,
}: Pick<MultiSelectProps<T>, 'options' | 'mode' | 'itemDisplay'>) => {
  return (
    <div className="max-h-[275px] overflow-y-auto p-1">
      {options.map((option) => {
        return (
          <div key={option.value}>
            <Option option={option} itemDisplay={itemDisplay} mode={mode} />
          </div>
        );
      })}
    </div>
  );
};
